<template>
  <div class="tree-view">
    <tree-view-item
      ref="treeView"
      :data="data[0]"
      :collapsed="true"
      :depth="0"
      :numbering="getNumbering()"
      :priority="priority == 'max'"
      :defaultValue="defaultValue"
      :titles="titles"
      @updated="$emit('updated')"
      v-bind="{ flat, focus, tips }"/>
  </div>
</template>

<script>
  export default {
    name: 'tree-view',

    props: {
      data: {
        required: true,
        type: [Array, Object],
      },
      defaultValue: {
        default: 5,
        type: Number
      },
      flat: {
        default: false,
        type: Boolean,
      },
      focus: {
        default: null,
        type: Object
      },
      numbering: {
        default: '',
        type: [String, Number]
      },
      priority: {
        default: 'min',
        type: String
      },
      tips: {
        type: String
      },
      titles: {
        type: String
      }
    },

    computed: {
      treeView () {
        return this.$refs.treeView;
      },
    },

    data: () => ({
      badge: null,
      selection: null,
    }),

    methods: {
      getMask () {
        return this.treeView.getMask([]);
      },

      /**
       * Returns correct numbering.
       */
      getNumbering () {
        // If has focus, use focussed element's numbering.
        if (this.focus && this.focus.getNumbering) {
          return this.focus.getNumbering();
        }

        return this.numbering;
      },

      hasChildren () {
        return Object.keys(this.children).length > 0;
      },

      notifySelection (item) {
        this.$emit('selection', item);
        this.$refs.treeView.setSelection(item);
      },

      update () {
        this.treeView.updateValues(this.data[0]);
      }
    },
  }
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/TreeView.vue